<!-- 客户列表 -->
<template>
    <div class="content">
        <div class="header">
            <div class="text">客户管理</div>
        </div>
        <!-- 搜索部分 -->
        <div class="search-box">
            <veui-form :data="formData" @submit="handleSubmit">
                <veui-field label="姓名" class="name">
                    <veui-input
                        v-model="formData.name"
                        placeholder="请输入姓名"
                    />
                </veui-field>
                <veui-field label="执业资格证号" class="certificate-no l">
                    <veui-input
                        v-model="formData.license"
                        placeholder="请输入资格证号"
                    />
                </veui-field>
                <veui-field label="手机号" class="l">
                    <veui-input
                        v-model="formData.phone"
                        placeholder="请输入手机号"
                    />
                </veui-field>
                <veui-field label="城市" class="city">
                    <citySelect
                        class="city-option"
                        :city="formData.city"
                        type="2"
                        @cityChange="cityChange"
                    />
                </veui-field>
                <veui-field label="会员类型" class="type l">
                    <veui-select
                        v-model="formData.codeType"
                        class="option"
                        placeholder="请选择"
                        :options="vipTypeOptions"
                        clearable
                    />
                </veui-field>
                <veui-field label="会员码属地" class="area l">
                    <veui-select
                        v-model="formData.cityLevel"
                        class="option"
                        placeholder="请选择"
                        :options="cityTypeOptions"
                        clearable
                    />
                </veui-field>
                <veui-field
                    v-if="!isAgentSubAccount"
                    label="销售成员"
                    class="member-name"
                >
                    <veui-select
                        v-model="formData.salesNameId"
                        class="option"
                        placeholder="请选择"
                        data-stat-ignore
                        :options="filterMemberList"
                        searchable
                    >
                    </veui-select>
                </veui-field>
                <template #actions>
                    <veui-button
                        ui="strong" @click="resetForm"
                    >重置</veui-button>
                    <veui-button ui="primary" type="submit">查询</veui-button>
                </template>
            </veui-form>
        </div>
        <!-- 表格数据 -->
        <div class="table-box">
            <veui-tabs
                ui="l"
                :active.sync="active"
                @change="tabChange"
            >
                <template v-for="({label, name}, index) in tabs">
                    <veui-tab
                        :key="index"
                        :label="label"
                        :name="name"
                    >
                        <template #label="{label, name}">
                            {{ label }}
                            <span
                                v-if="name === 'new'"
                            >({{ newNum || 0 }})</span>
                            <span
                                v-else-if="name === 'expire'"
                            >({{ expireNum || 0 }})</span>
                        </template>
                    </veui-tab>
                </template>
            </veui-tabs>
            <div
                v-if="!isAgentSubAccount"
                class="transfer-once"
                @click="handleTransfer"
            >批量转移客户</div>
            <!-- eslint-disable -->
            <div class="tip tab" ref="explainTip">
                <!-- eslint-disable -->
                <img class="icon" src="../../../assets/img/law/question.svg" />
                <div class="text">说明</div>
            </div>
            <veui-popover target="explainTip">
                新增客户：会员码绑定时间至查询时间在15日内的客户<br />
                临期客户：会员码过期时间至查询时间在15日内的客户
            </veui-popover>
            <veui-table
                :data="tableData"
                :scroll="{ x: 1104 }"
                role="columnheader"
                :order="order"
                :order-by="orderBy"
                :loading="isLoading"
                @sort="handleSort"
            >
                <veui-table-column
                    field="name"
                    title="客户名"
                    width="100"
                >
                    <template #default="{ name }">
                        <div class="table-name">{{ name }}</div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="enter_type"
                    title="线索来源"
                    width="120"
                >
                    <template #default="{ enter_type }">
                        {{ +enter_type === 2 ? '自主入驻' : '代理商引入'}}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="license"
                    title="执业资格证号"
                    width="190"
                />
                <veui-table-column
                    field="year"
                    title="执业年限"
                    width="120"
                >
                    <template #default="{ year }">
                        {{ year ? `执业${year}年` : '-' }}
                    </template>
                </veui-table-column>
                <veui-table-column field="phone" title="电话" width="140">
                    <template #default="{ phone }">
                        {{ phone || "-" }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="userType"
                    title="客户身份"
                    width="120"
                >
                    <template #default="{ userType }">
                        {{ userType | userTypeFilter }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="codeType"
                    title="会员类型"
                    width="100"
                >
                    <template #default="{ codeType }">
                        {{ codeTypeMap[codeType] || "-" }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="bindTime"
                    title="绑码时间"
                    width="140"
                    sortable
                >
                    <template #default="{ bindTime }">
                        {{ bindTime | dateFilter }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="validityStart"
                    title="会员码生效时间"
                    width="140"
                    sortable
                >
                    <template #default="{ validityStart }">
                        {{ validityStart | dateFilter }}
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="validityEnd"
                    title="会员码失效时间"
                    width="140"
                    sortable
                >
                    <template #default="{ validityEnd }">
                        {{ validityEnd | dateFilter }}
                    </template>
                </veui-table-column>
                <veui-table-column field="code" title="会员码" width="240" />
                <veui-table-column
                    field="firm_subaccount_name"
                    title="关联销售人员"
                    width="120"
                >
                </veui-table-column>
                <veui-table-column
                    field="operation"
                    title="操作"
                    width="140"
                    align="center"
                    fixed="right"
                >
                    <template #default="{ index }">
                        <veui-button
                            v-if="!isAgentSubAccount"
                            ui="text"
                            @click="openTransferCustomerDialog(index)"
                        >
                            转移客户
                        </veui-button>
                        <veui-button ui="text" @click="openDetail(index)">
                            详情
                        </veui-button>
                    </template>
                </veui-table-column>
            </veui-table>
            <!-- 分页 -->
            <veui-pagination
                v-if="tableData && tableData.length"
                :page="pn"
                :page-size="rn"
                :total="count"
                class="pagination"
                @redirect="pageChange"
            />
        </div>
        <!-- 详情 -->
        <customerDetail
            v-if="openDetailDrawer"
            :open="openDetailDrawer"
            :fid="fid"
            :lawyer="curLawyer"
            @closeDrawer="closeDetailDrawer"
        />
        <!-- 转移客户 -->
        <transfer-customer
            v-if="isShowTransferCustomerDialog"
            :open="isShowTransferCustomerDialog"
            :info="curLawyer"
            :trans-type="2"
            @close="updateTransferCustomerDialog"
            @updateList="getTableData"
        />
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 客户列表
 * @author dingzhenyue
 */
import {
    Select,
    Input,
    Form,
    Field,
    Button,
    Tab,
    Tabs,
    Table,
    Column,
    Pagination,
    Popover
} from 'veui';
import {mapState} from 'vuex';
import citySelect from '@/components/citySelect.vue';
import {userTypeFilter} from '../util/filter';
import {dateFilter} from '@/utils/filter';
import {vipTypeOptions, cityTypeOptions, codeTypeMap} from '../util/config';
import customerDetail from '../components/customer-detail.vue';
import transferCustomer from '@/components/firm/transfer-customer.vue';

export default {
    name: 'customer-list',
    components: {
        'veui-select': Select,
        'veui-input': Input,
        'veui-form': Form,
        'veui-field': Field,
        'veui-button': Button,
        'veui-tab': Tab,
        'veui-tabs': Tabs,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-pagination': Pagination,
        citySelect,
        customerDetail,
        'veui-popover': Popover,
        'transfer-customer': transferCustomer
    },
    filters: {
        userTypeFilter,
        dateFilter
    },
    data() {
        return {
            // 会员类型
            vipTypeOptions,
            formData: {
                name: '',
                // 资格证号
                license: '',
                phone: '',
                city: [],
                // 销售成员-默认全部
                salesNameId: -1,
                // 会员类型
                codeType: null,
                // 会员码归属地
                cityLevel: null
            },
            // 当前选中的tab
            active: '',
            // tab
            tabs: [
                {
                    label: '全部',
                    name: ''
                },
                {
                    label: '新增客户',
                    name: 'new',
                    num: 1
                },
                {
                    label: '临期客户',
                    name: 'expire',
                    num: 2
                }
            ],
            tableData: [],
            pn: 1,
            rn: 10,
            // 机构id
            fid: '',
            // 总数
            count: 0,
            // 排序顺序。为 false 时表示无序，为字符串值 'asc' / 'desc' 时分别为升序/降序。
            order: '',
            // 用于指定当前基于哪一列进行了排序，值必须来自内部某个 Column 组件的 field 属性
            orderBy: '',
            // 是否打开详情抽屉
            openDetailDrawer: false,
            // 新增
            newNum: 0,
            // 临期
            expireNum: 0,
            // 客保开始时间排序：0：不排序 1：正序 2：倒序
            orderValidityStartTime: '0',
            // 客保结束时间排序：0：不排序 1：正序 2：倒序
            orderValidityEndTime: '0',
            // 绑码束时间排序：0：不排序 1：正序 2：倒序
            orderBindTime: '2',
            // 当前选中的客户
            curLawyer: {},
            // 加载中
            isLoading: true,
            cityTypeOptions,
            // 会员类型
            codeTypeMap,
            isShowTransferCustomerDialog: false
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew,
            isAgentSubAccount: state => +state.lawStore.userInfoNew.user_role === 3,
            agentMemberData: state => state.lawStore.agentMemberData
        }),
        filterMemberList() {
            let agentMemberData = this.agentMemberData || [];
            agentMemberData.forEach(item => {
                item.label = item.name;
                item.value = item.id;
            });
            return [
                {
                    label: '全部',
                    value: -1
                },
                {
                    label: '未关联',
                    value: 0
                },
                ...agentMemberData
            ];
        }
    },
    watch: {
        userInfoNew: {
            deep: true,
            immediate: true,
            handler(newVal) {
                // 机构主账号
                if (newVal && newVal.law_firm_info) {
                    this.fid = newVal.law_firm_info?.id || '';
                }
                // 机构子账号
                else if (newVal && newVal.law_firm_subaccount) {
                    this.fid = newVal.law_firm_subaccount?.fid || '';
                }
                if (!this.fid) {
                    return;
                }
                // 页面曝光打点
                this.$log
                    && this.$log.send({
                        type: 'show',
                        value: 'customer-list',
                        page: window.location.pathname,
                        ext: {
                            fid: this.fid
                        }
                    });
                this.getTableData();
            }
        }
    },
    methods: {
        /**
         * 提交查询
         * @param {Object} data 表单信息
         */

        handleSubmit(data) {
            this.pn = 1;
            this.getTableData();
        },

        /**
         * 获取表格数据
         */

        getTableData() {
            this.isLoading = true;
            let index = this.tabs.findIndex(
                item => item.name === this.active
            );
            let params = {
                ...this.formatFormData(),
                orderBindTime: this.orderBindTime || '2',
                orderValidityStartTime: this.orderValidityStartTime || '0',
                orderValidityEndTime: this.orderValidityEndTime || '0',
                type: index < 0 ? 0 : index, // 全部
                pn: this.pn,
                rn: this.rn
            };
            this.$http
                .get('/bp/crm/getcustomerlist', {
                    params
                })
                .then(res => {
                    this.isLoading = false;
                    const data = this.$normalizeResponseData(res);
                    if (!data) {
                        this.tableData = [];
                        return;
                    }
                    this.tableData = data?.list || [];
                    this.count = data?.count || 0;
                    let info = data?.num || {};
                    this.newNum = +info?.new || 0; // 新增
                    this.expireNum = +info?.expire || 0; // 临期
                })
                .catch(err => {
                    this.$normalizeResponseError(err);
                    this.isLoading = false;
                });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.pn = pn;
            this.getTableData();
        },

        /**
         * 城市筛选过改变时
         * @param {Object} data 选中城市数据
         */

        cityChange(data = {}) {
            let {selectedData} = data;
            this.formData.city = selectedData;
        },

        /**
         * 排序时触发
         * @param {String} field 对哪一列排序
         * @param {String} order 排序顺序
         */

        handleSort(field, order) {
            this.order = order;
            this.orderBy = field;
            let orderObj = {
                asc: '1',
                desc: '2'
            };
            this.orderBindTime = '2';
            this.orderValidityStartTime
                = this.orderValidityEndTime
                = '0';
            switch (field) {
                case 'bindTime':
                    this.orderBindTime = order ? orderObj[order] : '2';
                    break;
                case 'validityStart':
                    this.orderValidityStartTime = order ? orderObj[order] : '0';
                    break;
                case 'validityEnd':
                    this.orderValidityEndTime = order ? orderObj[order] : '0';
            }
            this.getTableData();
        },

        /**
         * 切换tab
         */

        tabChange(tab) {
            // tab点击打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'customer-tab-click',
                    ext: {
                        tab: this.active
                    }
                });
            this.pn = 1;
            this.getTableData();
        },

        /**
         * 重置
         */

        resetForm() {
            this.formData = {
                name: '',
                license: '',
                phone: '',
                city: [],
                codeType: null,
                cityLevel: null,
                salesNameId: -1
            };
        },

        /**
         * 点击详情时触发
         * @param {Number} index 行下标
         */

        openDetail(index) {
            // 详情按钮的点击打点
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'cuatomer-detail-click'
                });
            let lawyer = this.tableData[index] || {};
            this.curLawyer = lawyer;
            this.openDetailDrawer = true;
        },

        /**
         * 关闭详情信息窗口
         */

        closeDetailDrawer() {
            this.openDetailDrawer = false;
        },

        /**
         * 更新转移客户弹窗
         */

        updateTransferCustomerDialog() {
            this.isShowTransferCustomerDialog = !this.isShowTransferCustomerDialog;
        },

        /**
         * 处理搜索参数
         */

        formatFormData() {
            let {codeType, cityLevel, city, license, phone, name, salesNameId}
                = this.formData || {};
            let params = {
                fid: this.fid,
                license,
                phone,
                name,
                firm_subaccount_id: salesNameId,
                codeType: codeType !== null ? codeType : '',
                cityLevel: cityLevel !== null ? cityLevel : '',
                city: city?.[1]?.value || ''
            };
            return params;
        },

        /**
         * 转移客户
         * @param {numebr} index 下标
         */

        openTransferCustomerDialog(index) {
            let lawyer = this.tableData[index] || {};
            this.curLawyer = lawyer;
            this.updateTransferCustomerDialog();
        },

        /**
         * 批量转移客户
         */

        handleTransfer() {
            this.curLawyer = {};
            this.updateTransferCustomerDialog();
        }
    }
};
</script>

<style lang='stylus' scoped>
@import "../../../assets/css/law-table.styl";

$inputWidth = 220px

.content {
    background: #fff;
    box-shadow: 0 6px 14px 0 rgba(227, 233, 237, .35);
    border-radius: 8px;
    padding: 32px 30px 24px;

    .header {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        position: relative;

        .text {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 18px;
        }
    }

    .search-box {
        .veui-form {
            display: flex;
            flex-wrap: wrap;
            position: relative;
        }

        .certificate-no,
        .name,
        .type,
        .city,
        .member-name {
            margin-right: 36px;
        }

        /deep/.veui-field {
            margin-bottom: 18px;
            height: 40px;

            .veui-field-label {
                height: 40px;
                margin-right: 0;
                width: 58px;
                text-align: left;
                line-height: 40px;
            }

            &.name,
            &.city,
            &.member-name {
                .veui-field-label {
                    justify-content: flex-start;
                }
            }

            &.l .veui-field-label {
                width: 85px;
            }

            &.m .veui-field-label {
                width: 58px;
            }

            &.member-name .veui-input.veui-focus {
                box-shadow: none;
            }
        }

        /deep/.veui-form-actions {
            margin-top: 0;
            padding-left: 0;

            .veui-button {
                margin-left: 0;

                &:last-child {
                    margin-left: 10px;
                }
            }
        }

        .veui-input {
            width: $inputWidth;
            height: 40px;
            margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            &.veui-focus,
            &:hover {
                border: 1px solid #3855d5;
                box-shadow: none;
            }
        }

        .veui-select.veui-select-expanded {
            border: 1px solid #3855d5;
        }

        /deep/.option {
            width: $inputWidth;
            height: 40px;
            margin-left: 20px;
            border: 1px solid #e9ecf3;
            border-radius: 8px;

            .veui-input {
                border: none;
            }

            &:focus,
            &:hover,
            &.veui-select-expanded {
                border: 1px solid #3855d5;
            }
        }

        .city-option {
            margin-left: 20px;

            /deep/.ivu-input {
                width: $inputWidth;
            }
        }
    }

    .table-box {
        position: relative;
        margin-top: 16px;

        .transfer-once {
            position: absolute;
            height: 48px;
            right: 0;
            top: 0;
            cursor: pointer;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #05f;
            line-height: 48px;
            font-weight: 400;
        }

        /deep/.veui-table [role="cell"] {
            padding: 9px 10px;
        }

        /deep/.veui-table [role="columnheader"] {
            padding: 19px 10px;
        }

        /deep/.veui-tabs-menu {
            .veui-tabs-item {
                margin: 22 0;
            }

            .veui-tabs-item-label {
                font-size: 14px;
                line-height: 14px;
            }

            .veui-tabs-prev,
            .veui-tabs-next {
                display: none;
            }

            .veui-tabs-item:not(:first-child) {
                margin-left: 10px;
            }
        }

        .tip {
            cursor: pointer;
            font-family: PingFangSC-Regular;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            display: flex;

            img {
                height: 12px;
                width: 12px;
            }

            .text {
                font-size: 12px;
                color: #333;
                line-height: 14px;
                margin-left: 4px;
            }

            &.tab {
                left: 360px;
                top: 25px;
                width: 50px;
            }
        }

        /deep/.veui-table {
            margin-top: 24px;

            .veui-table-cell-last {
                .veui-table-cell-content {
                    text-align: center;
                }
            }

            .veui-table-cell-content {
                position: relative;
                width: 100%;

                .status-dropdown,
                .ci-status {
                    padding-left: 12px;
                }

                .table-name {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .veui-button {
                    width: auto;
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #05f;
                    line-height: 16px;
                    font-weight: 400;
                }
            }
        }
    }

    .veui-button {
        height: 40px;
        width: 80px;
        font-size: 16px;
        border-radius: 5px;
    }

    .pagination {
        float: right;
        padding-top: 30px;
    }
}
</style>
